module.exports = __webpack_public_path__ + "7b652588f4ee157693cc2deb6f0fab50.MP3";